export function CanvaSlides() {
  return (
    <iframe
      loading="lazy"
      style={{
        position: 'relative',
        width: '51vw',
        height: '30vw',
        top: '0',
        left: '0',
        border: 'none',
        padding: '0',
        margin: '0',
      }}
      src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFcVVDJml4&#x2F;view?embed"
      allowFullScreen="allowfullscreen"
      allow="fullscreen"
    >
    </iframe>
  );
}
